import { render } from "./ShowPhenotypeComponent.vue?vue&type=template&id=667d0c96&scoped=true"
import script from "./ShowPhenotypeComponent.vue?vue&type=script&lang=js"
export * from "./ShowPhenotypeComponent.vue?vue&type=script&lang=js"

import "./ShowPhenotypeComponent.vue?vue&type=style&index=0&id=667d0c96&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667d0c96"]])

export default __exports__